import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "gridIsShow", true);
        Vue.set(state, "formIsShow", false);
    },
    openForm(state) {
        state.formIsShow = true;
        state.gridIsShow = false;
    },
    closeForm(state) {
        state.formIsShow = false;
        state.gridIsShow = true;
    }
}
